import { isNonEmptyString } from '@sniptt/guards';

import { CLERK_PUBLISHABLE_KEY } from '@/auth/constants/ClerkPublishableKey';
import { type AuthMode } from '@/auth/types/AuthMode';

// The one switch between real sign-in and the mock. With a Clerk publishable
// key, people sign in with Clerk. Without one, the app relies on the server's
// mock sign-in, so the starter runs before a Clerk account exists. The server
// must match (AUTH_PROVIDER=clerk or mock).
export const AUTH_MODE: AuthMode = isNonEmptyString(CLERK_PUBLISHABLE_KEY)
  ? 'clerk'
  : 'mock';
